import { AuthScreen } from "../auth/AuthScreen";

/**
 * /sign-in — the shared aurora auth screen in sign-in mode (web and native).
 * All auth mechanics live in auth/AuthScreen + auth/useAuthActions.
 */
const LoginPage = () => <AuthScreen mode="sign-in" />;

export default LoginPage;
